import { REACT_APP_BASE_MS_GW_API, REACT_APP_CAPTCHA_BASE_URL } from "../../../../../shared/constants";

export enum VehicleType {
    CICLOMOTORE = "C",
    AUTOVEICOLO = "A",
    MOTOVEICOLO = "M",
    RIMORCHIO = "R"
}

export enum ResultType {
   SOSPENDERE = "S",
   REGOLARE = "P",
   RIPETERE = "R"
}

export enum FieldsMinMax {
    LICENCE_CICLOMOTORE_NUMBER_MIN = 6,
    LICENCE_NUMBER_MIN = 7,
    LICENCE_NUMBER_MAX = 8,
}

/* URL */
const apiCaptchaUrl = REACT_APP_CAPTCHA_BASE_URL;
const apiExtramassaUrl = REACT_APP_BASE_MS_GW_API;
export const generateCaptchaURL = `${apiCaptchaUrl}/interrogazionistoricorevisioni/noauth/captcha/generate`;
export const validateCaptchaURL = `${apiCaptchaUrl}/interrogazionistoricorevisioni/noauth/captcha/verify`;
export const vehicleDataURL = `${apiExtramassaUrl}/interrogazionistoricorevisioni/api/v1/storicorevisioni`;

// URLs per ambiente locale
// export const generateCaptchaURL = `${apiCaptchaUrl}/noauth/captcha/generate`;
//export const validateCaptchaURL = `${apiCaptchaUrl}/noauth/captcha/verify`;
//export const vehicleDataURL = `${apiExtramassaUrl}/api/v1/storicorevisioni`;
